import { CommonPopup } from '../commonPopup/commonPopup.component';

export class ParentalFilterPopupLock extends CommonPopup {
  static _template() {
    return {
      ...super._template(),
      title: 'layout.locks.parentalFilter.message',
    };
  }
}
